import { render, staticRenderFns } from "./acquaring.vue?vue&type=template&id=3f97a787&scoped=true&"
import script from "./acquaring.vue?vue&type=script&lang=js&"
export * from "./acquaring.vue?vue&type=script&lang=js&"
import style0 from "./acquaring.vue?vue&type=style&index=0&id=3f97a787&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f97a787",
  null
  
)

export default component.exports